import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './../../../templates/forms/modals/serial-list.component.html',
})
export class SerialListComponent implements OnInit {
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;
  @Input()
  paramObj: any;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  serialList: any[] = [];
  searchFields: any[] = ['BATCH_NO', 'BATCH_QTY', 'SERIAL_NO', 'TRND_NO', 'ICCID', 'IMSI'];
  public searchString;

  constructor(public langService: LangService, private dataService: CommonService) { }

  ngOnInit() {
        this.dataService.getBatchNo(this.paramObj)
            .subscribe(arg => { this.serialList = arg.body });
    }

}
